import { auth, db } from './firebase';
import { collection, addDoc, doc, setDoc } from 'firebase/firestore';
import { 
  signInWithEmailAndPassword, 
  createUserWithEmailAndPassword, 
  signOut as firebaseSignOut,
  sendEmailVerification,
  User as FirebaseUser
} from 'firebase/auth';

export const authService = {
  register: async (email: string, password: string) => {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    
    // Send verification email
    await sendEmailVerification(userCredential.user);
    
    // Create user document using the auth UID
    await setDoc(doc(db, 'users', userCredential.user.uid), {
      uid: userCredential.user.uid,
      email: email,
      nationality: "",
      location: "",
      ethnicityPreference: "",
      displayName: "",
      age: "",
      gender: "",
      bio: "",
      interests: "",
      occupation: "",
      education: "",
      lookingFor: "",
      profilePicture: "",
      additionalPhotos: [],
      verificationSelfie: "",
      birthdate: "",
      matches: [],
      verified: false,
      verificationStatus: 'none',
      emailVerified: false,
    });

    return userCredential.user;
  },

  resendVerificationEmail: async (user: FirebaseUser) => {
    await sendEmailVerification(user);
  },

  checkEmailVerification: async (user: FirebaseUser) => {
    await user.reload();
    return user.emailVerified;
  },

  login: async (email: string, password: string) => {
    return await signInWithEmailAndPassword(auth, email, password);
  },

  logout: async () => {
    return await firebaseSignOut(auth);
  },

  checkAndUpdateEmailVerification: async (user: FirebaseUser) => {
    await user.reload(); // Refresh the user's token
    if (user.emailVerified) {
      const userRef = doc(db, 'users', user.uid);
      await setDoc(userRef, {
        emailVerified: true
      }, { merge: true });
    }
    return user.emailVerified;
  }
};